import React from 'react'
import { Box, Button, Typography, useMediaQuery } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from 'react-i18next'

import { SentimentButtonProps } from './SentimentOptions'
import { getScoreText, getSentimentButtonStyles } from './SentimentHelper'

const SentimentButton: React.FC<SentimentButtonProps> = ({
  sentimentObj,
  selectedOption,
  anchorEl,
  onClick,
  readonly,
  isScoreVisible,
}) => {
  const { t } = useTranslation()
  const { score, type } = sentimentObj || {}
  const { icon, value, color, hoverColor } = selectedOption || {}

  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('sm'),
  )
  const isReadonly = readonly || isSmallScreen
  const IconComponent = anchorEl ? KeyboardArrowUpIcon : KeyboardArrowDownIcon
  const endIcon = !isReadonly && <IconComponent color="disabled" />
  const scoreText = getScoreText(score, type)
  const buttonStyles = getSentimentButtonStyles(hoverColor, color, isReadonly)

  return (
    <Button
      fullWidth
      size="small"
      onClick={!isReadonly ? onClick : undefined}
      endIcon={endIcon}
      sx={buttonStyles}
      aria-label={`Sentiment button for ${value}`}
    >
      {selectedOption && (
        <Box display="flex" alignItems="center">
          <Box marginRight={1}>{icon}</Box>
          <Typography variant="subtitle2">
            {t(`textAnalysis.sentiment.${value}`)}
            {isScoreVisible && scoreText}
          </Typography>
        </Box>
      )}
    </Button>
  )
}

export default React.memo(SentimentButton)
